__turbopack_context__.v({
  "menuItem": "mobile-menu-module-scss-module__VtbXIG__menuItem",
  "menuItemWrapper": "mobile-menu-module-scss-module__VtbXIG__menuItemWrapper",
  "mobileApplyNowBtn": "mobile-menu-module-scss-module__VtbXIG__mobileApplyNowBtn",
  "mobileMenuContainer": "mobile-menu-module-scss-module__VtbXIG__mobileMenuContainer",
  "mobileMenuWrapper": "mobile-menu-module-scss-module__VtbXIG__mobileMenuWrapper",
  "open": "mobile-menu-module-scss-module__VtbXIG__open",
  "parentMainContainer": "mobile-menu-module-scss-module__VtbXIG__parentMainContainer",
  "studentCTA": "mobile-menu-module-scss-module__VtbXIG__studentCTA",
  "studentLogin": "mobile-menu-module-scss-module__VtbXIG__studentLogin",
});
